module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-7.d7934672.jpg";